import { MediaAction } from '../sdk/types/media';

export function isMediaEnd(action: MediaAction) {
  return action < MediaAction.CALL_PUT_THROUGH;
}
